import {Nullish} from 'shared/web';

export type PlainBasket<T> = {
  items: T[] | Nullish;
  isLoading: boolean;
  hasError: boolean;
  isDeletingItems: boolean;
};
